"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tooltip = exports.ToolotipPosition = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _TooltipComponent = require("./components/TooltipComponent.js");
var _themeProvider = require("../../../theme/themeProvider/index.js");
var _StyledToolTip = require("./components/StyledToolTip.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["children", "width", "height", "bg", "content", "position", "contentSize"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let ToolotipPosition = exports.ToolotipPosition = /*#__PURE__*/function (ToolotipPosition) {
  ToolotipPosition["top"] = "top";
  ToolotipPosition["bottom"] = "bottom";
  ToolotipPosition["left"] = "left";
  ToolotipPosition["right"] = "right";
  return ToolotipPosition;
}({});
const Tooltip = props => {
  const theme = (0, _themeProvider.useTheme)();
  const {
      children,
      width = 'auto',
      height = 'auto',
      bg = theme.color.tooltipBgColor,
      content,
      position = 'bottom',
      contentSize = '14px'
    } = props,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  const [active, setActive] = (0, _react.useState)(false);
  const className = 'tooltip ' + position;
  function handleOnMouseEnter() {
    setActive(true);
  }
  function handleOnMouseLeave() {
    setActive(false);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TooltipComponent.TooltipComponent, Object.assign({
    width: width,
    height: height,
    bg: bg,
    onMouseEnter: handleOnMouseEnter,
    onMouseLeave: handleOnMouseLeave,
    tooltipPosition: position
  }, rest, {
    children: [children, active && /*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledToolTip.TooltipContent, {
      fontSize: contentSize,
      className: className,
      children: content
    })]
  }));
};
exports.Tooltip = Tooltip;
var _default = exports.default = Tooltip;